import React from 'react'
import useUser from '../hooks/useUser';
import WriteLog from '../libs/WriteLog';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import useWorkOrder from '../hooks/useWorkOrder';
import useEstimate from '../hooks/useEstimate';
import { PreviewReport } from './Globals/Functions';
import useSchedule from '../hooks/useSchedule';


//icons
import{    
    MapPinIcon,
    ArrowDownTrayIcon,
    EyeIcon,
}from "@heroicons/react/24/outline"



function Dashboard() {    

    const { user } = useUser();
    WriteLog("Schedule->user", user);
        
    //schedule    
    const {schedules} = useSchedule(user?.customer_code, user?.token, "-1");    
    WriteLog("Home->scheduls", schedules?.appointments);      

    //active order
    const { workorders } = useWorkOrder(user?.customer_code, "-1", user?.token);          
    WriteLog("Home->workorders", workorders?.wo_history);    
    
    //estimate
    var {estimates} = useEstimate(user?.customer_code, "-1", user?.token)    
    WriteLog("Home->estimates", estimates);    

    //report
    const [reportLoading, setReportLoading] = useState(false)
    

    return (                        
        <div className="w-screen m-10">  
            <div className='text-3xl'>
                    Dashboard
            </div>
            <div className="flex mt-5">            
                <div className='flex w-1/2'>
                    <div className='w-1/2 m-1'>
                        <div className='p-2 rounded-xl bg-white'>
                        <div className='flex border-b-2 items-center justify-between space-x-2 bg-slate-100 rounded-lg p-2'>
                            <div className='flex items-center space-x-2'>
                                <div>Schedule :</div>
                                <div className='flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-300'>{schedules?.appointments.length}</div>                        
                            </div>                        
                            <div>
                                {!schedules &&
                                    <CircularProgress size={20} color='primary'></CircularProgress>
                                }                            
                            </div>                        
                        </div>
                        <div className='mt-2 overflow-y-auto'>
                            {schedules?.appointments.map((sch)=>(
                            <div className='border-b-2 p-1'>
                                <div className='flex justify-between'>
                                    <div className='flex space-x-4'>
                                        <div className=' text-slate-900 pl-1 pr-1 rounded-lg' style={{backgroundColor:sch.job_cat_color}} >{sch.work_order_id}</div>
                                        <div>{sch.wo_description}</div> 
                                    </div>                                
                                    <div className="text-gray-500 text-sm">{sch?.start_date !== "" &&
                                        new Intl.DateTimeFormat("en-GB", {
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit", 
                                        hour: 'numeric', 
                                        minute: 'numeric',                                     
                                        hour12: true,                                               
                                        }).format(new Date(sch?.start_date))}
                                    </div>
                                </div>
                                <div className='flex items-center'>   
                                    <MapPinIcon className='w-4 h-4 text-blue-900'></MapPinIcon>
                                    <div>{sch.location_name}</div>                            
                                </div>
                                <div className='flex items-center text-sm italic text-gray-500'>
                                    {sch.full_address}
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                    </div>
                    <div className='w-1/2 m-1'>
                        <div className='p-2 rounded-xl bg-white'>
                        <div className='flex border-b-2 items-center justify-between space-x-2 bg-slate-100 rounded-lg p-2'>
                            <div className='flex items-center space-x-2'>
                                <div>Active Orders:</div>
                                <div className='flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-300'>{workorders?.wo_history.length}</div>                         
                            </div>                        
                            <div>
                                {!workorders &&
                                    <CircularProgress size={20} color='primary'></CircularProgress>
                                }                            
                            </div>                         
                        </div>
                        <div className='mt-2 overflow-y-auto'>
                            {workorders?.wo_history?.map((wo)=>(
                            <div className='border-b-2 p-1'>
                                <div className='flex space-x-4 justify-between items-center'>
                                    <div className='flex space-x-3'>
                                        <div className=' text-slate-900 pl-1 pr-1 rounded-lg' style={{backgroundColor:wo.job_cat_color}} >{wo.serv_order}</div>
                                        <div>{wo.wo_description}</div>                         
                                    </div>                                
                                    <div className="text-sm bg-gray-200 text-orange-500 pl-2 pr-2 rounded-full text-center">{wo.is_complete === true?"Completed":"In Process"}</div>
                                </div>
                                <div className='flex items-center'>   
                                    <MapPinIcon className='w-4 h-4 text-blue-900'></MapPinIcon>
                                    <div>{wo.location_name}</div>                            
                                </div>
                                <div className='flex items-center text-sm italic text-gray-500'>
                                    {wo.full_address}
                                </div> 
                            </div>
                            ))}
                        </div>
                    </div>
                    </div>
                </div>            
                <div className='flex w-1/2'>
                    <div className='w-1/2 m-1'>
                        <div className='p-2 rounded-xl bg-white'>
                        <div className='flex border-b-2 items-center justify-between space-x-2 bg-slate-100 rounded-lg p-2'>
                            <div className='flex items-center space-x-2'>
                                <div>Estimates:</div>
                                <div className='flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-300'>{estimates?.length}</div>                         
                            </div>                        
                            <div>
                                {!estimates &&
                                    <CircularProgress size={20} color='primary'></CircularProgress>
                                }                            
                            </div>                        
                        </div>
                        <div className='mt-2 overflow-y-auto'>
                            {estimates?.map((est)=>(
                            <div className='border-b-2 p-1'>
                                <div className='flex space-x-4 items-center text-center text-white'>                            
                                    {est.status === 0 &&
                                        <div className='bg-[#FF7B54] w-16 rounded-lg'>{est.est_nbr}</div>
                                    }
                                    {est.status === 1 &&
                                        <div className='bg-[#24a33f] w-16 rounded-lg'>{est.est_nbr}</div>
                                    }
                                    {est.status === 2 &&
                                        <div className='bg-[#ed6666] w-16 rounded-lg'>{est.est_nbr}</div>
                                    }
                                    <div className='text-black'>{est.desc}</div>                            
                                    <div>${est.dest_total}</div>
                                </div>
                                <div className='flex items-center'>                                   
                                    
                                </div>
                                <div className='flex items-center'>   
                                    <MapPinIcon className='w-4 h-4 text-blue-900'></MapPinIcon>
                                    <div>{est.location_name}</div>                            
                                </div>
                                <div className='flex items-center text-sm italic text-gray-500'>
                                    {est.full_address}
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                    </div>
                    <div className='w-1/2 m-1'>
                        <div className='p-2 rounded-xl bg-white'>
                        <div className='flex border-b-2 justify-between items-center space-x-2 bg-slate-100 rounded-lg p-2'>
                            <div className='flex items-center space-x-2'>
                                <div>Reports:</div>
                                <div className='flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-300'>{workorders?.wo_history?.length}</div>    
                            </div>                        
                            <div>
                                {reportLoading &&
                                    <CircularProgress size={20} color='primary'></CircularProgress>
                                }                            
                            </div>                     
                        </div>
                        <div className='mt-2 overflow-y-auto'>
                            {workorders?.wo_history?.map((wo)=>(
                            <div className='border-b-2 p-1'>
                                <div className='flex space-x-4 justify-between items-center'>
                                    <div className='flex space-x-3'>
                                        <div className=' text-slate-900 pl-1 pr-1 rounded-lg' style={{backgroundColor:wo.job_cat_color}} >{wo.serv_order}</div>
                                        <div>{wo.wo_description}</div>                         
                                    </div>                                
                                    {wo.ins_prpt_release === 1 &&
                                        <div className='bg-slate-100 rounded-xl p-1'>
                                            <div className='flex justify-evenly text-gray-400 cursor-pointer space-x-2 items-center'>
                                                <div className='p-1 rounded-full hover:bg-gray-300'>
                                                    <EyeIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>PreviewReport(e, wo.serv_order, setReportLoading, user?.token)} />                                    
                                                </div>                                            
                                                <div className='p-1 rounded-full hover:bg-gray-300'>
                                                    <ArrowDownTrayIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>PreviewReport(e, wo.serv_order, setReportLoading, user?.token)} />
                                                </div>                                            
                                            </div>
                                        </div>
                                        // <div className="text-sm text-white bg-green-600 pl-3 pr-3 rounded-full text-center cursor-pointer" onClick={(e)=>PreviewReport(e, wo.serv_order, setReportLoading, user?.token)}>Available</div>
                                    }

                                    {wo.ins_prpt_release === 0 &&
                                        <div className="text-sm text-black bg-orange-100 pl-3 pr-3 rounded-full text-center">In Process</div>
                                    }
                                    
                                </div>
                                <div className='flex items-center'>   
                                    <MapPinIcon className='w-4 h-4 text-blue-900'></MapPinIcon>
                                    <div>{wo.location_name}</div>                            
                                </div> 
                                <div className='flex items-center text-sm italic text-gray-500'>
                                    {wo.full_address}
                                </div>                           
                            </div>
                            ))}
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>        
    )}    
export default Dashboard